import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { playChatSound } from "@/lib/chatSession";

const BASE_TITLE = document.title;

// Polls unread counts (works while chat is locked: no content). Drives badge, tab title and sound.
export function useChatUnread(enabled, chatOpen) {
  const [total, setTotal] = useState(0);
  const prev = useRef(null);
  useEffect(() => {
    if (!enabled) return undefined;
    const tick = () => api.get("/chat/unread").then(({ data }) => {
      const p = prev.current;
      if (p) {
        const grew = Object.entries(data.by_branch).filter(([b, n]) => n > (p.by_branch[b] || 0)).map(([b]) => b);
        const onlyActive = grew.length > 0 && grew.every((b) => b === window.__chatActiveConv);
        if (grew.length && !(chatOpen && document.hasFocus() && onlyActive)) playChatSound();
      }
      prev.current = data;
      setTotal(data.total);
    }).catch(() => {});
    tick();
    const t = setInterval(tick, 4000);
    return () => clearInterval(t);
  }, [enabled, chatOpen]);
  useEffect(() => { document.title = total > 0 ? `(${total}) ABCD Pay` : BASE_TITLE; }, [total]);
  useEffect(() => () => { document.title = BASE_TITLE; }, []);
  return total;
}
